export const paymentFrequencyConst = [
    {
        label: "ANNUAL",
        value: "ANNUAL",
        fractional: 1
    }, {
        label: "HALF_YEARLY",
        value: "HALF_YEARLY",
        fractional: 2

    }, {
        label: "FOUR_MONTHLY",
        value: "FOUR_MONTHLY",
        fractional: 3

    }, {
        label: "QUARTERLY",
        value: "QUARTERLY",
        fractional: 4

    }, {
        label: "BIMONTHLY",
        value: "BIMONTHLY",
        fractional: 6

    }, {
        label: "MONTHLY",
        value: "MONTHLY",
        fractional: 12

    }, {
        label: "FORTNIGHTLY",
        value: "FORTNIGHTLY",
        fractional: 24

    }, {
        label: "WEEKLY",
        value: "WEEKLY",
        fractional: 48

    }, {
        label: "UNIQUE",
        value: "UNIQUE",
        fractional: 1

    }
]
